import React, { ReactNode } from 'react';

import './PopupContextMenu.css';

export interface ItemType {
  label: string;
  icon: ReactNode;
  key: string | number;
  onClick?: (it: any) => void;
  disabled?: boolean | ((record: any) => boolean);
}

export interface Menu {
  items: ItemType[];
  onClick: (it: ItemType, record?: any) => void;
}

export type MenuProps = Menu | false;

export interface ContextMenuProps<T> {
  currentRecord: T;
  selectedRecords: T[];
  menu: MenuProps;
  visible: boolean;
  x: number;
  y: number;
  setContextMenuState: (state: any) => void;
}

const PopupContextMenu = ({
  menu,
  visible,
  x,
  y,
  currentRecord,
  setContextMenuState,
}: ContextMenuProps<any>) => {
  if (!menu) return null;

  const { items, onClick } = menu;

  const boxHeight = 32 * items.length + 8;
  const boxWidth = 200;
  let boxStyle: any = { zIndex: 2 };

  if (boxHeight + y > window.innerHeight) {
    boxStyle = {
      ...boxStyle,
      bottom: `${window.innerHeight - y}px`,
      top: 'unset',
    };
  } else {
    boxStyle = { ...boxStyle, top: `${y}px` };
  }

  if (boxWidth + x > window.innerWidth) {
    boxStyle = {
      ...boxStyle,
      right: `${window.innerWidth - x}px`,
      left: 'unset',
    };
  } else {
    boxStyle = { ...boxStyle, left: `${x}px` };
  }

  return (
    <div
      style={{
        userSelect: 'none',
        touchAction: 'none',
      }}
    >
      {visible &&
        items?.some(
          (it) =>
            !(
              typeof it.disabled === 'function' && it.disabled(currentRecord)
            ) && it.disabled !== true
        ) && (
          <>
            <div
              className="overlay-bg"
              style={{
                position: 'fixed',
                left: 0,
                top: 0,
                right: 0,
                bottom: 0,
                opacity: 0.5,
                zIndex: 1,
                userSelect: 'none',
                touchAction: 'none',
              }}
              onMouseDown={() => {
                setContextMenuState({ visible: false });
              }}
            ></div>
            <ul
              className="popup border-background-light-5 bg-background-light-5 text-black dark:border-background-dark-5 dark:bg-background-dark-5 dark:text-white"
              style={boxStyle}
            >
              {items.map((it, idx) => {
                if (
                  (typeof it.disabled === 'function' &&
                    it.disabled(currentRecord)) ||
                  it.disabled === true
                )
                  return null;

                return (
                  <li
                    className="flex cursor-pointer items-center text-base"
                    key={it.key}
                    onClick={() => {
                      onClick(it);
                    }}
                  >
                    <span style={{ marginRight: 10 }}>{it.icon}</span>
                    <span>{it.label}</span>
                  </li>
                );
              })}
            </ul>
          </>
        )}
    </div>
  );
};

export default React.memo(PopupContextMenu);
